import {ID} from '../../../../../../_metronic/helpers'
import {UserModel} from '../../../../auth'
import {Stock, StockQueryResponse} from '../../stock-list/core/_models'
import {stockEvents, stockEventsForJob, deleteAllocate} from './StockEvents.amplify'

const getEventsForStock = async (query: string, currentUser: UserModel | undefined, id: ID, pageParam?: any): Promise<StockQueryResponse> => {
  if (currentUser) {
    if (pageParam) {
      query += `&last_evaluated_key_pk=${encodeURIComponent(pageParam.pk)}&last_evaluated_key_sk=${encodeURIComponent(pageParam.sk)}&last_evaluated_key_gsi1pk=${encodeURIComponent(pageParam.gsi1pk)}&last_evaluated_key_gsi1sk=${encodeURIComponent(pageParam.gsi1sk)}`
    }

    return stockEvents(currentUser, id, query).then((result) => {
      return result
    })
  } else {
    return Promise.reject(new Error('Current user is null'))
  }
}

const getStockEventsForJob = async (currentUser: UserModel | undefined, id: ID): Promise<StockQueryResponse> => {
  if (currentUser) {
    return stockEventsForJob(currentUser, id).then((result) => {
      return result
    })
  } else {
    return Promise.reject(new Error('Current user is null'))
  }
}

const deleteAllocateStock = (currentUser: UserModel | undefined, stockEventId: ID): Promise<Stock | undefined> => {
  if (currentUser && stockEventId) {
    return deleteAllocate(currentUser, stockEventId).then((result) => {
      return result.data
    })
  } else {
    return Promise.reject(new Error('Current user is null'))
  }
}

export {getEventsForStock, getStockEventsForJob, deleteAllocateStock}
